import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/content';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  const hasDetails = Boolean(volume.items && volume.items.length > 0);
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-300" data-mp="b6g7agdy3bm5">
      <div className="mx-auto max-w-6xl" data-id="element-301" data-mp="b4lj8t7dn3du">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-302" data-mp="fxelnafdhzmr">
          What’s Inside <em className="text-red-700" data-id="element-303" data-mp="23x41v68ywzd">SALSA &amp; BACHATA READY™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-304" data-mp="752x5u3tkm9f">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-305" data-mp="3odzsakkj8gmp">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-306" data-mp="3ctxkyynmuh3j">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumes" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-307" data-mp="37v30ztdximhu">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-308" data-mp="3hsr0sxqe6k6v" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-309" data-mp="2adm9f5i2cgq3">Volume</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-310" data-mp="26d2bw0tkvb3f">{item.number.replace('Volume ', '')}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-311" data-mp="9cob0ultt2eq">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-312" data-mp="j3srjyr5gvbo">
          <AnimatePresence mode="wait" initial={false} data-id="element-313" data-mp="3mjzkpbbxva67">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-314" data-mp="3mlkdavep0j1f">
              {hasDetails ? <>
                  <div className="lg:col-span-5" data-id="element-315" data-mp="1btsonbfet43z">
                    <p className="text-sm font-semibold text-red-700" data-id="element-316" data-mp="1gpzxpd33qvq5">
                      {volume.number} · {volume.title}
                    </p>
                    <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-317" data-mp="31awk4t4ggf49">{volume.heading}</h4>
                    <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-318" data-mp="2rj0jpbewccwv">{volume.intro}</p>
                  </div>
                  <div className="lg:col-span-7" data-id="element-319" data-mp="2mkpdrbrq2mjx">
                    <p className="text-sm font-semibold text-slate-900/60" data-id="element-320" data-mp="2mhtd3fohpjrs">Includes:</p>
                    <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-321" data-mp="2hm5p33lquwnv">
                      {volume.items?.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-322" data-mp="2dlc1ycg4llw1">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-323" data-mp="28lzfvtx2wiui" />
                          {entry}
                        </li>)}
                    </ul>
                    {volume.outro && <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-324" data-mp="1tydq1gagxvs">{volume.outro}</p>}
                  </div>
                </> : <div className="lg:col-span-8" data-id="element-325" data-mp="2vm6e862rs9lx">
                  <p className="text-sm font-semibold text-red-700" data-id="element-326" data-mp="2zn024zg7poet">{volume.number}</p>
                  <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-327" data-mp="2lnh6350oe3iv">{volume.title}</h4>
                  <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-328" data-mp="2qm26p5juap7u">{volume.description}</p>
                </div>}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-329" data-mp="2go5ltm13ofwj">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-330" data-mp="2gqid4psr02m9">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-331" data-mp="22yaj35sumpr9">
              What Makes SALSA &amp; BACHATA READY™ Different?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-332" data-mp="1syjol44agar6">
              A Full Year of Salsa &amp; Bachata Teaching Material — Organised and Ready to Use.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-333" data-mp="1ed5wdc2oxngn">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-334" data-mp="1oa0sxpfeldsa">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-335" data-mp="1ob3fjl5p0u2e" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-336" data-mp="1jafstbohyzdz">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-337" data-mp="1x9ffwewd3681">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}